import React, { useContext} from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Pagination from "@material-ui/lab/Pagination";
//import TableContainer from "@material-ui/core/TableContainer";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Loading from "../core/Loading";
import AlertPermanent from "../core/AlertPermanent";
import AuthContext from "../../context/authentication/authContext";
import TableContext from "../../context/table/tableContext";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ReceiverContext from '../../context/receiver/ReceiverContext'

const styles = (theme) => ({
  root: {
    display: "flex",
    marginTop: theme.spacing(3),
    height: "100%",
    overflow: 'auto',
  },
  table: {
    minWidth: 340,
  },
  tableCell: {
    padding: "16px",
    color: "#12b1ee",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 70,
  },
  documentNumber: {
    cursor: "pointer",
  },
  actionIcon:{
    cursor:'pointer',
    paddingLeft:'15px',
    fontSize: '2.5rem',
    color:'#001070'
  }
  ,
  deleteIcon:{
    cursor:'pointer',
    paddingLeft:'15px',
    fontSize: '2.5rem',
    color:'rgba(218, 41, 29, 0.86)'
  }
});

const CustomerTable = (props) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext; //closeSession,,  hasToChange
  const [currentReceivers,setData] = React.useState()
  const [customerId,setCustomerId] = React.useState()
  const{
    receivers,
    completed,
    getReceiver,
    deleteReceiver,
    currentType,
    showEditReceiver,
    totalPages,
    filterCriteria,
    currentPage,
    maxPerPage,
    setCurrentPage,
    setMaxPerPage,
    setFilterCriteria
  } = useContext(ReceiverContext)
  const {
    error,
    errorMessage,
  } =  useContext(TableContext)
  const {
    classes,
    columns,
  } = props;
  const handlePagination = (e, page) => {
    e.preventDefault();
    //changePage(page);
    setCurrentPage(page)
   //  //console.log('getReceiver handlePagination')

    getReceiver(customerId,currentType,filterCriteria,page,maxPerPage)
  };

  const handleChangeRowsPerPage = (e) => {
    const newMax=parseInt(e.target.value)
   // //console.log(newMax)
    setMaxPerPage(newMax);
    setCurrentPage(1)
    getReceiver(customerId,currentType,filterCriteria,1,newMax)
  };


  function editReceiver(event){
    try{
       const list = receivers.filter(x=>x.id===parseInt(event.currentTarget.attributes.receiverid.value))
      ////console.table(list)
      if(list && list.length>0){
        showEditReceiver(list[0] ,currentType)
      }
    }catch(error){
        //console.table(error)
    }
  }

  function deleteThisReceiver(event){
    try{
        if(window.confirm('¿Está seguro de eliminar este item?')){
        deleteReceiver({receiverId:parseInt(event.currentTarget.attributes.receiverid.value),customerId})
    }
    }catch(error){
        //console.table(error)
    }
  }
  React.useEffect(()=>{
      // //console.log(completed)
       if(completed==="COMPLETED"){
         //   //console.log('getReceiver completed')
            getReceiver(customerId,currentType,filterCriteria,currentPage,maxPerPage)
       }
  },[completed])
  let working = false
  React.useEffect(()=>{
    //  if(totalItems)setTotalReceivers(totalItems)
     // if(totalPages)setTotalPages(totalPages)
     // if(totalItemsInPage)setTotalReceivers(totalItemsInPage)
     if(customerId && currentType && currentPage && maxPerPage&&filterCriteria){
          working = true
         // //console.log('getReceiver maxPerPage' ,customerId , currentType , currentPage , maxPerPage)
          getReceiver(customerId,currentType,filterCriteria,currentPage,maxPerPage)

     }

  },[customerId , currentType , currentPage , maxPerPage,filterCriteria])

  React.useEffect(()=>{
     //     //console.table(receivers)
          if(receivers)setData(receivers)
  },[receivers])

   React.useEffect(()=>{
      const customers = JSON.parse(localStorage.getItem('customers'))
      setCustomerId(customers[0].id)
    },[])

  if (!currentReceivers) {
    return <Loading />;
  }

  if (currentReceivers.length === 0 && !error) {
    return ( <div style={{margin:'20px'}}>
      <AlertPermanent
        category="info"
        message="No se han encontrado registros..."
      /></div>
    );
  }
  if (errorMessage) {
      return (
      <div style={{margin:'20px'}}>
          <AlertPermanent category="error" message={errorMessage} />
      </div>);
  }
  return (
    <>

      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                (column.name !== "Estado" || (user != null ? user.includes("tas_") : false)) &&
                <TableCell
                  key={index}
                  align={column.name === "Monto" ? "right" : "center"}
                  className={classes.tableCell}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentReceivers.map((n) => {
              return (
                <TableRow key={n.id}>
                  <TableCell
                    component="th"
                    scope="row"
                    className={classes.TableCell}
                    align="center">
                    {n.fiscalKey}
                  </TableCell>
                  <TableCell align="center">
                    {n.fiscalName}
                  </TableCell>
                  <TableCell align="center">{n.category}</TableCell>
                  <TableCell align="center"
                    className={classes.documentNumber}
                    >{n.address}</TableCell>
                  <TableCell align="center">
                    {n.commune}
                  </TableCell>
                  <TableCell align="center">
                    <EditIcon onClick={editReceiver} receiverid={n.id} className={classes.actionIcon} />
                    <DeleteIcon onClick={deleteThisReceiver} receiverid={n.id} className={classes.deleteIcon} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Paper>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FormControl className={classes.formControl}>
          <InputLabel id="demo-simple-select-label">Registros</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={maxPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={500}>500</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          page={currentPage}
          count={totalPages}
          onChange={handlePagination}
          showFirstButton showLastButton
          style={{ marginTop: "10px", justifyContent: "center" }}
        />
      </div>
    </>
  );
};

export default withStyles(styles)(CustomerTable
    );
